/**
 * @generated SignedSource<<49722c51727491c9bad3aa1cb004921f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
export type projectResolverLabelQuery$variables = {
  key: string;
};
export type projectResolverLabelQuery$data = {
  readonly project: {
    readonly key: string;
    readonly name: string;
    readonly uuid: string;
  } | null;
};
export type projectResolverLabelQuery = {
  response: projectResolverLabelQuery$data;
  variables: projectResolverLabelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "key"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "uuid"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "projectResolverLabelQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v1/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "projectResolverLabelQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v1/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "54cbf75bc5fd714d15ab433109744275",
    "id": null,
    "metadata": {},
    "name": "projectResolverLabelQuery",
    "operationKind": "query",
    "text": "query projectResolverLabelQuery(\n  $key: String!\n) {\n  project: projectByKey(key: $key) {\n    key\n    name\n    uuid\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4aabec5cac62b736ca770b4621630826";

export default node;
